"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
interface SpecItem {
  id: number;
  label: string;
  value: string;
}
const trailerSpecs: SpecItem[] = [{
  id: 1,
  label: "Exterior Dimensions",
  value: "53′ L × 102.36″ W × 13′ 6″ H"
}, {
  id: 2,
  label: "Interior Dimensions",
  value: "Approximately 52′ 2″ L × 97.4″ W × 105.5″ H"
}, {
  id: 3,
  label: "Temperature Range",
  value: "Pending confirmation"
}, {
  id: 4,
  label: "Power / Fuel Requirements",
  value: "Pending confirmation"
}, {
  id: 5,
  label: "Capacity",
  value: "Pending confirmation"
}, {
  id: 6,
  label: "Loading Requirements",
  value: "Pending confirmation"
}, {
  id: 7,
  label: "Rental Duration",
  value: "Pending confirmation"
}];
export default function Specifications() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: "easeOut"
      }
    }
  };
  const dimensionSpecs = trailerSpecs.slice(0, 2);
  const remainingSpecs = trailerSpecs.slice(2);
  return <section id="specifications" data-nav="light" className="bg-background py-16 md:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <Badge variant="outline" className="mb-4 border-border bg-muted/60 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Technical Specifications
          </Badge>
          <h2 className="font-default text-2xl sm:text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            53-Foot Reefer Trailer Specifications
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="mt-12 space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {dimensionSpecs.map((spec, i) => <motion.div key={spec.id} variants={itemVariants} data-index={i}>
                <Card className="h-full rounded-lg border border-dashed border-border bg-muted/40 p-6 flex flex-col justify-between gap-4 shadow-none">
                  <div className="space-y-1.5">
                    <span className="block text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      {spec.label}
                    </span>
                  </div>
                  <div className="rounded-md border border-dashed border-border/80 bg-background/80 px-3.5 py-2.5">
                    <span className="text-sm md:text-base font-medium text-foreground">
                      {spec.value}
                    </span>
                  </div>
                </Card>
              </motion.div>)}
          </div>

          <motion.p variants={itemVariants} className="text-xs text-muted-foreground">
            Dimensions shown are typical manufacturer dimensions for a 53-foot reefer trailer. Exact measurements may vary by trailer configuration and are confirmed individually.
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {remainingSpecs.map((spec, i) => <motion.div key={spec.id} variants={itemVariants} data-index={i}>
                <Card className="h-full rounded-lg border border-dashed border-border bg-muted/40 p-6 flex flex-col justify-between gap-4 shadow-none">
                  <div className="space-y-1.5">
                    <span className="block text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      {spec.label}
                    </span>
                  </div>
                  <div className="rounded-md border border-dashed border-border/80 bg-background/80 px-3.5 py-2.5">
                    <span className="text-sm md:text-base font-medium text-foreground">
                      {spec.value}
                    </span>
                  </div>
                </Card>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}